/* Project register.
   ------------------------------------------------------------------
   The shipped work that does not carry a full case study on this page.

   Descriptors are factual and deliberately flat. Several of these repos
   describe themselves more ambitiously than their code supports, so each
   line says what the thing is, not what it was hoped to be.

   Years are when the work was done, not the last commit. Several of these
   were pushed to a personal repository months after delivery, so their
   commit dates understate them - do not re-derive the years from git.

   Six of the seven are the shipped work behind the hero's twenty, counted
   with the thirteen case studies and Bespoke, which lives inside the
   Responsible With AI card. ShipEase predates that window. */

export const REGISTER_NOTE =
  "Thirteen case studies above \u00b7 seven below \u00b7 twenty shipped across 2025 and 2026, plus earlier client work";

export const PROJECT_REGISTER = [
  {
    n: "01",
    name: "Kora",
    what: "Freelance marketplace — Laravel API, React Native clients",
    client: "Alliance Tech",
    year: "2025",
  },
  {
    n: "02",
    name: "Contractly",
    what: "Contract lifecycle interface with a paginated document editor",
    client: "Alliance Tech",
    year: "2025",
  },
  {
    n: "03",
    name: "ChatOn",
    what: "Reusable React Native chat client, sold to two clients and integrated into their own apps",
    client: "Own product",
    year: "2025",
  },
  {
    n: "04",
    name: "RAGnet",
    what: "Social content automation on n8n, with an LLM agent and scrapers",
    client: "Green Touch",
    year: "2025",
  },
  {
    n: "05",
    name: "Vidos Solutions",
    what: "Company website",
    client: "Feenix Limited",
    year: "2026",
  },
  {
    n: "06",
    name: "Feenix Observatory",
    what: "Reporting dashboard over the shared capture database",
    client: "Feenix Limited",
    year: "2026",
  },
  {
    n: "07",
    name: "ShipEase",
    what: "Freight logistics platform — web console, React Native app, API",
    client: "Toptal · also the final year project",
    year: "2024",
  },
];
